import { Grid, Paper, Typography } from "@mui/material";
import PropTypes from "prop-types";

import { formatDate } from "@/features/shared";

export const GeneralInformationSection = ({ stockAdjustment }) => {
  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1">Informasi Umum</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Tanggal Transaksi
          </Typography>
          <Typography variant="body1">
            {formatDate(stockAdjustment.transactionDate)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Outlet
          </Typography>
          <Typography variant="body1">
            {stockAdjustment.outlet?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Gudang
          </Typography>
          <Typography variant="body1">
            {stockAdjustment.warehouse?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Akun Penyesuaian
          </Typography>
          <Typography variant="body1">
            {stockAdjustment.adjustmentOutletChartOfAccount
              ? `${stockAdjustment.adjustmentOutletChartOfAccount.code} - ${stockAdjustment.adjustmentOutletChartOfAccount.name}`
              : "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Catatan
          </Typography>
          <Typography variant="body1">
            {stockAdjustment.note || "-"}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

GeneralInformationSection.propTypes = {
  stockAdjustment: PropTypes.object.isRequired,
};
